import { getLoginUrl, login } from '@npm/sso-auth'
import { useCallback, useEffect, useState } from 'react'

import { Modal } from '../modal'

import type { FC } from 'react'

interface LoginMessage {
  type: string
  payload: {
    ticket: string
    token: string
    status: 'success' | 'fail'
  }
}

export const Login: FC = () => {
  const [visible, setVisible] = useState(false)

  const trigger = useCallback(() => {
    const w = window.innerWidth
    if (w <= 480) {
      login()
      return
    }

    setVisible(prev => !prev)
  }, [])

  const handleMessage = useCallback(
    (event: MessageEvent<LoginMessage>) => {
      const { type, payload } = event.data || {}
      if (type === 'login' && payload.status === 'success') {
        location.reload()
        setTimeout(() => {
          setVisible(false)
        }, 500)
      }
    },
    [setVisible]
  )

  useEffect(() => {
    window.loginModal = { trigger }
    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [handleMessage, trigger])

  return (
    <Modal
      bodyClassName='login-modal'
      height={640}
      title=''
      visible={visible}
      width={400}
      onClose={trigger}
    >
      <iframe
        src={getLoginUrl({ auth_mode: 'modal' })}
        style={{ width: '100%', height: '100%', border: 'none' }}
        title='login-iframe'
      />
    </Modal>
  )
}
